import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SvgIcon as BaseSvgIcon } from "@mui/material";
import { ColorsInjector } from "../../../utils";
/**
 * @deprecated Please use Svg from `/lab`
 */
export const SvgIcon = (props) => {
    return (_jsx(ColorsInjector, { props: props, children: ({ size, fontSize = typeof size === "number" ? "medium" : size, color = "inherit", colorSet, invertColors = true, getColorStyles, ...rootProps }) => {
            const colorStyles = getColorStyles({
                color,
                colorSet,
                invertColors,
            });
            return (_jsx(BaseSvgIcon, { "data-component-name": "SvgIcon", ...rootProps, fontSize: fontSize, sx: {
                    color: colorStyles.color,
                    width: props.width
                        ? "unset"
                        : typeof size === "number"
                            ? "auto"
                            : "1em",
                    height: (theme) => props.height
                        ? "unset"
                        : typeof size === "number"
                            ? theme.spacing(size)
                            : "1em",
                    verticalAlign: "sub",
                    ...rootProps.sx,
                } }));
        } }));
};
//# sourceMappingURL=SvgIcon.js.map